import { useTranslation } from "react-i18next";

const ContactInformation = ({
    typo14,
}) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        <div className="tw:rounded-[5px] tw:bg-[#f9f9f9] tw:px-7 tw:py-5">
            <div className={`tw:font-hanken-grotesk tw:text-center tw:text-[#282828] ${typo14}`}>
                <div dangerouslySetInnerHTML={{ __html: t("bookingDetail.contactInformation.note") }} />
            </div>
        </div>
    );
};

export default ContactInformation;